var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Management-guide-content-main",class:{ 'Management-guide-content-main-mobile': _vm.isMobile }},[_c('div',{staticClass:"main"},[_c('ManagementGuideContentItem',{attrs:{"data":_vm.dataList}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }